import React from "react";

export const RADIATE = "https://www.radiateapp.com/";
export const APP_STORE = "https://apps.apple.com/us/app/radiate-meditation-app/id6757485959";

export const Hero = () => (
  <div className="hero" data-testid="hero" style={{ backgroundImage: "url(/mm/sea.webp)" }}>
    <div className="hero-veil" />
    <div className="hero-row">
      <span>Modern Mind</span>
      <span className="right">by Amber Lyon</span>
    </div>
    <div className="hero-center">
      <h1 className="hero-title" data-testid="hero-title">Manifest</h1>
      <p className="hero-sub" data-testid="hero-sub">The Modern Mind Manifestation Method.<br />My five-step method to consciously creating your life.</p>
      <a href="#intro" className="text-btn hero-begin" data-testid="hero-begin-link">Begin</a>
    </div>
    <div className="hero-bottom">
      <span>clarity &middot; authenticity &middot; being &middot; appreciation &middot; shadow</span>
    </div>
  </div>
);

const IntroVideo = () => (
  <div className="video-frame">
    <video controls playsInline preload="metadata" poster="/mm/amber-poster.jpg" src="/mm/amber-intro.mp4" data-testid="hero-video" />
  </div>
);

const skip = () => document.getElementById("step-1")?.scrollIntoView({ behavior: "smooth", block: "start" });

export const Intro = () => (
  <section className="intro reveal" id="intro" data-testid="intro-section">
    <div className="container">
      <div className="label">Before you begin</div>
      <h2>Hi, Amber here.</h2>
      <p>I've coached hundreds of individuals on how to find joy while creating magnetic and abundant lives. Here I wanted to share my go-to practice with you, where we break down step by step how to take a vision and make it REAL. Not someplace out ahead of you or for some future version of yourself, but for the you of today.</p>
      <p>Here's a little video from me, or you're welcome to skip and dive right in.</p>
      <IntroVideo />
      <div className="text-center">
        <button className="text-btn mt-8" onClick={skip} data-testid="skip-video-btn">Skip the video</button>
      </div>
    </div>
  </section>
);
